// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Redux:
import { setCookieConsent } from 'actions/site'

class CookieConsent extends React.Component {
	maxAge = 60 * 60 * 24 * 365 // 1 year.

	handleAccept = () => {
		const { dispatch } = this.props

		document.cookie = `cookies_consent=1;max-age=${this.maxAge};path=/`

		dispatch( setCookieConsent( 1 ) )
	}

	handleRefuse = () => {
		document.cookie = `cookies_consent=0;max-age=${this.maxAge};path=/`

		dispatch( setCookieConsent( 0 ) )
	}

	render() {
		const { cookieConsent, inGdprZone } = this.props

		// cookieConsent:
		// null - not set.
		// 0 - consent denied.
		// 1 - consent given.
		if ( ! inGdprZone || null !== cookieConsent ) {
			return null
		}

		return (
			<div className="cookie-consent">
				<div className="-inner">
					<div className="-text">
						<p>
							This site uses cookies to offer you a better browsing experience.
						</p>
					</div>

					<div className="-actions">
						<div className="button -refuse is-small" onClick={ this.handleRefuse }>
							Refuse cookies
						</div>

						<div className="button -accept is-small" onClick={ this.handleAccept }>
							Accept and continue
						</div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		inGdprZone: state.site.inGdprZone,
		cookieConsent: state.site.cookieConsent
	}
}

export default connect( mapStateToProps )( CookieConsent )
